// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rj-0";